import React from 'react';

export const SvgSymbols = React.memo(() => (
	<React.Fragment>
		<symbol id="check-icon" viewBox="0 0 512 512">
			<path
				fill="currentColor"
				d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
			/>
		</symbol>
		<symbol id="close-icon" viewBox="0 0 18 18">
			<path
				d="M15.0607 0.93934C15.6464 1.52513 15.6464 2.47487 15.0607 3.06066L3.06066 15.0607C2.47487 15.6464 1.52513 15.6464 0.93934 15.0607C0.353553 14.4749 0.353553 13.5251 0.93934 12.9393L12.9393 0.93934C13.5251 0.353553 14.4749 0.353553 15.0607 0.93934Z"
				fill="currentColor"
			/>
			<path
				d="M0.93934 0.93934C1.52513 0.353553 2.47487 0.353553 3.06066 0.93934L15.0607 12.9393C15.6464 13.5251 15.6464 14.4749 15.0607 15.0607C14.4749 15.6464 13.5251 15.6464 12.9393 15.0607L0.93934 3.06066C0.353553 2.47487 0.353553 1.52513 0.93934 0.93934Z"
				fill="currentColor"
			/>
		</symbol>
		<symbol id="star-icon" viewBox="0 0 24 23">
			<path
				d="M11.993 0.501953C12.564 0.501953 13.0854 0.826104 13.3381 1.33811L16.0749 6.88362L22.1941 7.77046C22.7595 7.8524 23.2292 8.24834 23.4057 8.79166C23.5821 9.33498 23.4346 9.93136 23.0253 10.3298L18.5909 14.6463L19.6364 20.7413C19.733 21.3044 19.5014 21.8733 19.0391 22.2089C18.5768 22.5444 17.9641 22.5883 17.4587 22.322L11.9992 19.4451L6.52605 22.3226C6.02066 22.5883 5.40825 22.5441 4.94632 22.2085C4.48439 21.8729 4.25306 21.3041 4.3496 20.7413L5.39515 14.6463L0.960734 10.3298C0.551389 9.93136 0.403903 9.33498 0.580342 8.79166C0.756781 8.24834 1.22651 7.8524 1.79186 7.77046L7.91106 6.88362L10.6479 1.33811C10.9006 0.826104 11.422 0.501953 11.993 0.501953Z"
				fill="currentColor"
			/>
		</symbol>
		<symbol id="watch-icon" viewBox="0 0 22 23">
			<path
				d="M9.23777 0.648427C11.3858 0.282764 13.5944 0.594434 15.5574 1.54023C17.5204 2.48603 19.1406 4.01911 20.1932 5.92693C21.2459 7.83475 21.679 10.0228 21.4324 12.1878C21.3386 13.0109 20.5954 13.6021 19.7723 13.5084C18.9492 13.4146 18.3579 12.6714 18.4516 11.8483C18.6278 10.3019 18.3185 8.73897 17.5665 7.37624C16.8146 6.01351 15.6574 4.91846 14.2553 4.24289C12.8531 3.56732 11.2755 3.34469 9.74121 3.60588C8.20688 3.86707 6.79181 4.59913 5.69217 5.70058C4.59253 6.80202 3.8628 8.21829 3.60413 9.75305C3.34546 11.2878 3.57068 12.865 4.24855 14.2661C4.92642 15.6671 6.02337 16.8225 7.38733 17.5722C8.7513 18.3218 10.3147 18.6286 11.8608 18.4499C12.6838 18.3548 13.428 18.9449 13.5231 19.7678C13.6182 20.5908 13.0282 21.335 12.2052 21.4301C10.0406 21.6802 7.85188 21.2508 5.94234 20.2013C4.03279 19.1517 2.49706 17.5341 1.54804 15.5727C0.599015 13.6112 0.283717 11.4031 0.645852 9.25446C1.00799 7.1058 2.02962 5.12302 3.56911 3.581C5.10861 2.03897 7.0897 1.01409 9.23777 0.648427Z"
				fill="currentColor"
			/>
			<path
				d="M11 4.50002C11.8284 4.50002 12.5 5.17159 12.5 6.00002V10.3787L14.0607 11.9394C14.6465 12.5251 14.6465 13.4749 14.0607 14.0607C13.4749 14.6465 12.5251 14.6465 11.9394 14.0607L9.93935 12.0607C9.65805 11.7794 9.50001 11.3978 9.50001 11V6.00002C9.50001 5.17159 10.1716 4.50002 11 4.50002Z"
				fill="currentColor"
			/>
		</symbol>
	</React.Fragment>
));

SvgSymbols.displayName = 'SvgSymbols';
